import { Container } from "@mui/material";
import { DataStoreBreadcrumbs } from "~/components/DataStoreBreadcrumbs";
import { Page } from "~/components/Page";
import { LabelDetails } from "./components/LabelDetails";

export function LabelPage() {
  return (
    <Page title="Label Details">
      <Container fixed>
        <DataStoreBreadcrumbs />
        <LabelDetails />
      </Container>
    </Page>
  );
}
